import { Table, TableContainer, Tbody, Thead, Tr } from '@chakra-ui/react';
import { useState } from 'react';
import ApplicationsRow from './ApplicationsRow';
import BookRow from './BookRow';
import Header from './Header';
import { applicationsColumns, bookColumns } from './columns';

const BookTable = ({ bookData, setOrderBy, sortColumn, sortDirection, tabIndex }) => {
  // Resources
  const isApplications = tabIndex === 0;
  const columns = isApplications ? applicationsColumns : bookColumns;

  // State
  const [expandedRow, setExpandedRow] = useState(null);

  const renderRows = () => {
    if (isApplications) {
      return bookData?.rows.map((row, index) => <ApplicationsRow columns={columns} key={index} row={row} />);
    }

    return bookData?.rows?.map((row, index) => (
      <BookRow
        columns={columns}
        expandedRow={expandedRow}
        id={index}
        row={row}
        setExpandedRow={setExpandedRow}
        key={index}
      />
    ));
  };

  return (
    <TableContainer>
      <Table variant="simple" size="md">
        <Thead>
          <Tr>
            {columns.map((column) => (
              <Header
                key={column.label}
                column={column}
                setOrderBy={setOrderBy}
                sortColumn={sortColumn}
                sortDirection={sortDirection}
              />
            ))}
          </Tr>
        </Thead>
        <Tbody>{renderRows()}</Tbody>
      </Table>
    </TableContainer>
  );
};

export default BookTable;
